export const formatCurrency = (value: number, currency: string, locale: string = "es-MX") => {
    return value.toLocaleString(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: true,
        currency: currency,
        style: "currency",
    })
};